// [US 6.13/6.17] Capture d'écran Sentinel dans un cadre stylé + légende.
// Partagée entre la landing (SentinelLandingPage) et la section promo de la Home.
// Cadre 16/10 + `object-cover` → l'image est agrandie pour remplir le cadre (zoom, sans bande) ;
// l'excédent panoramique est rogné. `objectPosition` ancre le recadrage (ex. 'left' pour ne pas
// couper les pastilles/labels à gauche). `src` absent → placeholder de secours (grille de points).
import React from 'react';
import { Image as ImageIcon } from 'lucide-react';

export const ScreenshotPlaceholder: React.FC<{ caption: string; icon: React.ReactNode; src?: string; alt?: string; objectPosition?: string }> = ({ caption, icon, src, alt, objectPosition }) => (
    <div className="relative rounded-2xl border border-[#1E2A3F] bg-[#0B1120] aspect-[16/10] overflow-hidden flex flex-col items-center justify-center gap-3"
        style={src ? undefined : { backgroundImage: 'linear-gradient(180deg, rgba(34,211,165,.05), rgba(11,17,32,0) 60%)' }}>
        {src ? (
            <img src={src} alt={alt ?? caption} loading="lazy" className="absolute inset-0 w-full h-full object-cover"
                style={{ objectPosition: objectPosition ?? 'center' }} />
        ) : (
            <>
                <div className="absolute inset-0 opacity-[0.15]"
                    style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, #22D3A5 1px, transparent 0)', backgroundSize: '22px 22px' }} />
                <div className="relative z-10 w-12 h-12 rounded-xl border border-[#22D3A5]/30 bg-[#22D3A5]/10 flex items-center justify-center text-[#22D3A5]">
                    {icon}
                </div>
                <div className="relative z-10 flex items-center gap-1.5 text-[11px] uppercase tracking-[.18em] text-[#5A6A82] font-semibold">
                    <ImageIcon size={13} /> {caption}
                </div>
            </>
        )}
    </div>
);
